/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import preview from 'ui/components/theme/preview.mixin';

const __vue_script__ = {
    name: 'RequestPreview',

    mixins: [preview],
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"request-preview",attrs:{"viewBox":"0 0 900 500","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#clip_page_shape)"}},[(_vm.backgroundImageUrl)?_c('image',{attrs:{"href":_vm.backgroundImageUrl,"width":"900","height":"500","preserveAspectRatio":"xMidYMid slice"}}):_vm._e(),_c('g',{staticClass:"card"},[_c('rect',{attrs:{"x":"250","y":"20","width":"400","height":"450","rx":"8","fill":"#FFFFFF","stroke":"#E5E6E6","stroke-width":"0.5"}}),_c('g',{staticClass:"header"},[_c('rect',{attrs:{"x":"280","y":"40","width":"150","height":"24","rx":"2","fill":"#000000"}})]),_c('g',{staticClass:"description"},[_c('rect',{attrs:{"x":"280","y":"75","width":"330","height":"6","rx":"2","fill":"#E5E6E6"}}),_c('rect',{attrs:{"x":"280","y":"85","width":"300","height":"6","rx":"2","fill":"#E5E6E6"}}),_c('rect',{attrs:{"x":"280","y":"95","width":"280","height":"6","rx":"2","fill":"#E5E6E6"}})]),_c('rect',{attrs:{"x":"280","y":"120","width":"80","height":"6","rx":"2","fill":"#000000"}}),_c('g',{staticClass:"dropdown"},[_c('rect',{attrs:{"x":"280","y":"130","width":"330","height":"31","rx":"4","fill":"#FFFFFF","stroke":"#E5E6E6","stroke-width":"1"}}),_c('rect',{attrs:{"x":"290","y":"143","width":"150","height":"6","rx":"2","fill":"#E5E6E6"}}),_c('path',{attrs:{"d":"M588 143l5 5 5-5","stroke-width":"1.3","stroke-linecap":"round","stroke-linejoin":"round","stroke":"#000000"}})]),_c('rect',{attrs:{"x":"280","y":"185","width":"100","height":"6","rx":"2","fill":"#000000"}}),_c('rect',{attrs:{"x":"280","y":"197","width":"200","height":"9","rx":"2","fill":"#000000"}}),_c('rect',{attrs:{"x":"280","y":"212","width":"150","height":"6","rx":"2","fill":"#ADADAD"}}),_c('g',{staticClass:"time_slots"},[_c('g',{staticClass:"column1"},[_c('rect',{attrs:{"x":"315","y":"255","width":"60","height":"15","rx":"2","fill":"#000000"}}),_c('rect',{attrs:{"x":"325","y":"275","width":"40","height":"10","rx":"2","fill":"#E5E6E6"}}),_c('rect',{attrs:{"x":"295","y":"295","width":"100","height":"35","rx":"4","fill":"#FFFFFF","stroke":_vm.primaryColor || '#2D76E5',"stroke-width":"1.5"}}),_c('rect',{attrs:{"x":"295.5","y":"295.5","width":"99","height":"34","rx":"3.5","fill-opacity":"0.35","fill":_vm.primaryColor || '#2D76E5'}}),_c('rect',{attrs:{"x":"325","y":"310","width":"40","height":"8","rx":"2","fill":"#E5E6E6"}}),_c('rect',{attrs:{"x":"295","y":"340","width":"100","height":"35","rx":"4","fill":"#FFFFFF","stroke":"#E5E6E6","stroke-width":"0.5"}}),_c('rect',{attrs:{"x":"325","y":"355","width":"40","height":"8","rx":"2","fill":"#E5E6E6"}}),_c('rect',{attrs:{"x":"295","y":"385","width":"100","height":"35","rx":"4","fill":"#FFFFFF","stroke":"#E5E6E6","stroke-width":"0.5"}}),_c('rect',{attrs:{"x":"325","y":"400","width":"40","height":"8","rx":"2","fill":"#E5E6E6"}})]),_c('g',{staticClass:"column2"},[_c('rect',{attrs:{"x":"420","y":"255","width":"60","height":"15","rx":"2","fill":"#000000"}}),_c('rect',{attrs:{"x":"430","y":"275","width":"40","height":"10","rx":"2","fill":"#E5E6E6"}}),_c('rect',{attrs:{"x":"400","y":"295","width":"100","height":"35","rx":"4","fill":"#FFFFFF","stroke":_vm.primaryColor || '#2D76E5',"stroke-width":"1.5"}}),_c('rect',{attrs:{"x":"400.5","y":"295.5","width":"99","height":"34","rx":"3.5","fill-opacity":"0.35","fill":_vm.primaryColor || '#2D76E5'}}),_c('rect',{attrs:{"x":"430","y":"310","width":"40","height":"8","rx":"2","fill":"#E5E6E6"}}),_c('rect',{attrs:{"x":"400","y":"340","width":"100","height":"35","rx":"4","fill":"#FFFFFF","stroke":_vm.primaryColor || '#2D76E5',"stroke-width":"1.5"}}),_c('rect',{attrs:{"x":"400.5","y":"340.5","width":"99","height":"34","rx":"3.5","fill-opacity":"0.35","fill":_vm.primaryColor || '#2D76E5'}}),_c('rect',{attrs:{"x":"430","y":"355","width":"40","height":"8","rx":"2","fill":"#E5E6E6"}}),_c('rect',{attrs:{"x":"400","y":"385","width":"100","height":"35","rx":"4","fill":"#FFFFFF","stroke":"#E5E6E6","stroke-width":"0.5"}}),_c('rect',{attrs:{"x":"430","y":"400","width":"40","height":"8","rx":"2","fill":"#E5E6E6"}})]),_c('g',{staticClass:"column3"},[_c('rect',{attrs:{"x":"525","y":"255","width":"60","height":"15","rx":"2","fill":"#000000"}}),_c('rect',{attrs:{"x":"535","y":"275","width":"40","height":"10","rx":"2","fill":"#E5E6E6"}}),_c('rect',{attrs:{"x":"505","y":"295","width":"100","height":"35","rx":"4","fill":"#FFFFFF","stroke":"#E5E6E6","stroke-width":"0.5"}}),_c('rect',{attrs:{"x":"535","y":"310","width":"40","height":"8","rx":"2","fill":"#E5E6E6"}}),_c('rect',{attrs:{"x":"505","y":"340","width":"100","height":"35","rx":"4","fill":"#FFFFFF","stroke":"#E5E6E6","stroke-width":"0.5"}}),_c('rect',{attrs:{"x":"535","y":"355","width":"40","height":"8","rx":"2","fill":"#E5E6E6"}}),_c('rect',{attrs:{"x":"505","y":"385","width":"100","height":"35","rx":"4","fill":"#FFFFFF","stroke":_vm.primaryColor || '#2D76E5',"stroke-width":"1.5"}}),_c('rect',{attrs:{"x":"505.5","y":"385.5","width":"99","height":"34","rx":"3.5","fill-opacity":"0.35","fill":_vm.primaryColor || '#2D76E5'}}),_c('rect',{attrs:{"x":"535","y":"400","width":"40","height":"8","rx":"2","fill":"#E5E6E6"}})])]),_c('g',{staticClass:"submit_button"},[_c('rect',{attrs:{"x":"276","y":"435","width":"350","height":"32","rx":"4","fill":_vm.primaryColor || '#2D76E5'}}),_c('rect',{attrs:{"x":"410","y":"447","width":"80","height":"8","rx":"2","fill":"#FFFFFF"}})])]),_c('rect',{staticClass:"page_borders",attrs:{"x":"0.5","y":"0.5","width":"899","height":"799","rx":"7.5","stroke":"#E5E6E6"}})])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "RequestPreview.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__